import { render, staticRenderFns } from "./PanelCompetitionDashboard.vue?vue&type=template&id=15895a6f&scoped=true&"
import script from "./PanelCompetitionDashboard.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionDashboard.vue?vue&type=style&index=0&id=15895a6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15895a6f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15895a6f')) {
      api.createRecord('15895a6f', component.options)
    } else {
      api.reload('15895a6f', component.options)
    }
    module.hot.accept("./PanelCompetitionDashboard.vue?vue&type=template&id=15895a6f&scoped=true&", function () {
      api.rerender('15895a6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PanelCompetitionDashboard.vue"
export default component.exports